var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-text',{staticClass:"text-center"},[_c('p',[_vm._v("Please wait while you're redirected back to Nexus Connect.")]),_c('p',[_vm._v("Redirecting you in "+_vm._s(_vm.seconds)+"...")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }